export default __webpack_public_path__ + "static/media/AM_00819 copy.8877ddbb.jpg";